export { default } from './FAQ';



// WEBPACK FOOTER //
// ./src/components/Help/FAQ/index.ts